import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from 'react';

import {
  Container,
  Content,
  AlteredHeader,
  ComboProps,
} from 'styles/sgo_wrappers';
import { useHistory, useLocation } from 'react-router-dom';

import { useSpring } from 'react-spring';

import SGOHeader from 'components/SGOHeader';
import SGONavbar from 'components/SGONavbar';
import ScrollTop from 'components/ScrollTop';
import SGOFooter from 'components/SGOFooter';
import RadioContainer from 'components/RadioContainer';
import Textarea from 'components/Textarea';
import Loading from 'components/Loading';
import Button from 'components/Button';
import SelectV2 from 'components/SelectV2';

import api from 'services/api';

import { useCredentials } from 'hooks/credentials';
import { useAuth } from 'hooks/auth';
import { useToast } from 'hooks/toast';
import { useWindow } from 'hooks/window';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import {
  FaBook,
  FaPhotoVideo,
  // FaTshirt,
  FaPlusSquare,
  FaSortDown,
  FaSortUp,
  FaTimesCircle,
  FaArrowLeft,
} from 'react-icons/fa';
import { calcTotal, formatNumber } from 'utils/calcTotal';
import { checkAddress } from 'utils/specialChars';

import { alphaMasking } from 'components/Textarea/masks';

import {
  PreINC,
  ProceedButton,
  PhaseOne,
  PhaseTwo,
  ItemContainer,
  PhaseOneItemContainer,
  AddButton,
  Grid,
  GridItem,
  InfoContainer,
  TotalSolic,
  FinishButton,
  PhaseThree,
  ReturnButton,
} from './styles';

interface GroupSelectedProps {
  cod: string;
  desc: string;
}

export interface ItemsProps {
  matcod: string;
  matdesc: string;
  cost: number;
  quantity: number;
  stored: number;
}

interface DeliverAddressProps {
  value: string;
  label: string;
}

const PedidoInsert: React.FC = () => {
  const phaseOne = useRef<FormHandles>(null);
  const phaseTwo = useRef<FormHandles>(null);
  const phaseThree = useRef<FormHandles>(null);

  const [isPreInc, setIsPreInc] = useState(true);
  const [isPhaseOne, setIsPhaseOne] = useState(false);
  const [isPhaseTwo, setIsPhaseTwo] = useState(false);
  const [isPhaseThree, setIsPhaseThree] = useState(false);

  const { pathname } = useLocation();
  const history = useHistory();
  const { width } = useWindow();
  const { user } = useAuth();
  const { addToast } = useToast();
  const { errorHandling, handlePermission } = useCredentials();
  const [loading, setLoading] = useState(true);

  const [accept, setAccept] = useState('');

  const [mats, setMats] = useState<ComboProps[]>([]);
  const [rawMats, setRawMats] = useState<ComboProps[]>([]);
  const [storageQuantity, setStorageQuantity] = useState('-');
  const [cost, setCost] = useState(0);
  const [items, setItems] = useState<ItemsProps[]>([]);
  const [deliverAddress, setDeliverAddress] = useState('');
  const [pAddress, setPAddress] = useState('');
  const [sAddress, setSAddress] = useState('');

  const [deliverAble, setDeliverAble] = useState(false);
  const [groupSelected, setGroupSelected] = useState<GroupSelectedProps>(
    {} as GroupSelectedProps,
  );

  const getAddress = useCallback(async () => {
    const response = await api.get<{ PRINC: string; SEC: string }>(
      `/sgo/getAddress.php?data=${JSON.stringify({
        trans: 'pedido',
      })}`,
    );

    const { PRINC, SEC } = response.data;

    if (PRINC && SEC) {
      if (checkAddress(PRINC) === checkAddress(SEC)) {
        setDeliverAddress(PRINC);
      } else {
        setDeliverAble(true);
        setDeliverAddress(PRINC);
        setPAddress(PRINC);
        setSAddress(SEC);
        phaseThree.current?.setFieldValue('deliver', 'P');
      }
    } else if (!PRINC && SEC) {
      setDeliverAddress(SEC);
    } else if (!SEC && PRINC) {
      setDeliverAddress(PRINC);
    } else {
      return null;
    }
  }, []);

  const getComboMATS = useCallback(async () => {
    try {
      const response = await api.get('/combos/comboMATs.php?from=pedido');
      setRawMats(
        response.data.filter(
          (item: ComboProps) => item.value.substr(0, 2) !== 'DM',
        ),
      );

      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandling(err);
    }
  }, [errorHandling]);

  useEffect(() => {
    handlePermission(['NAC'], true);
    getComboMATS();
  }, [handlePermission, getComboMATS]);

  const handleRadioClick = useCallback(() => {
    getAddress();
    const value = phaseOne.current?.getFieldValue('group');

    setGroupSelected({
      cod: value,
      desc: value === 'G' ? 'Gráfica' : value === 'C' ? 'Malharia' : 'Mídia',
    });

    setMats(rawMats.filter((item: ComboProps) => item.matgrped === value));

    setIsPhaseOne((state) => !state);
    setIsPhaseTwo((state) => !state);
  }, [rawMats, getAddress]);

  const handleRadioClick2 = useCallback(() => {
    const value = phaseThree.current?.getFieldValue('deliver');

    setDeliverAddress(value === 'P' ? pAddress : sAddress);
  }, [pAddress, sAddress]);

  const handleMaterialSelect = useCallback(async () => {
    try {
      setLoading(true);
      phaseTwo.current?.setErrors({});
      const material = phaseTwo.current?.getFieldValue('material');

      const send = JSON.stringify({
        matcod: material,
        trans: 'pedido',
      });
      const response = await api.get(`/sgo/getStorage.php?data=${send}`);
      const { quantity, matcost } = response.data;

      setStorageQuantity(quantity);
      setCost(matcost);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandling(err);
    }
  }, [errorHandling]);

  const total = useMemo(() => {
    return items.reduce((accum, { quantity, cost: value }: ItemsProps) => {
      const semitotal = accum + quantity * value;
      return semitotal;
    }, 0);
  }, [items]);

  const handlePushMaterial = useCallback(() => {
    const index = mats.findIndex(
      (item: ComboProps) =>
        item.value === phaseTwo.current?.getFieldValue('material'),
    );

    phaseTwo.current?.setErrors({});

    if (index > -1) {
      const newMat = {
        matcod: mats[index].value,
        matdesc: mats[index].label,
        cost,
        quantity: 1,
        stored: parseInt(storageQuantity, 10),
      };

      setItems((state) => [newMat, ...state]);

      setMats((state) =>
        state.filter((item: ComboProps) => item.value !== newMat.matcod),
      );
      setStorageQuantity('-');
      setCost(0);
    } else {
      phaseTwo.current?.setFieldError(
        'material',
        'You must select at least one material',
      );

      addToast({
        type: 'info',
        title: ``,
        description: 'É necessário escolher um material.',
      });
    }

    phaseTwo.current?.setFieldValue('material', '');
  }, [addToast, cost, mats, storageQuantity]);

  const handleAdd = useCallback(
    (material: string) => {
      const index = items.findIndex(
        (item: ItemsProps) => item.matcod === material,
      );

      if (index > -1) {
        items[index].quantity += 1;
        setItems((state) => [...state]);
      }
    },
    [items],
  );

  const handleSub = useCallback(
    (material: string) => {
      const index = items.findIndex(
        (item: ItemsProps) => item.matcod === material,
      );

      if (index > -1) {
        items[index].quantity -= 1;
        setItems((state) =>
          items[index].quantity === 0
            ? [...state].filter(
                (item: ItemsProps) => item.matcod !== items[index].matcod,
              )
            : [...state],
        );

        if (items[index].quantity === 0) {
          const rearrange = [
            ...mats,
            rawMats[
              rawMats.findIndex(
                (item: ComboProps) => item.value === items[index].matcod,
              )
            ],
          ].sort((a, b) => (a.label > b.label ? 1 : -1));

          setMats(rearrange);
        }
      }
    },
    [items, mats, rawMats],
  );

  const handleInputChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>, mat: string) => {
      const index = items.findIndex((item: ItemsProps) => item.matcod === mat);
      const number = e.currentTarget.value.replace(/^0/, '');
      if (number.length > 0) {
        const asNum = parseInt(number, 10);

        if (index > -1) {
          items[index].quantity = asNum;
          setItems((state) =>
            items[index].quantity <= 0
              ? [...state].filter(
                  (item: ItemsProps) => item.matcod !== items[index].matcod,
                )
              : [...state],
          );
        }
      } else {
        items[index].quantity = 0;
        setItems((state) => [...state]);
      }

      e.currentTarget.value = e.currentTarget.value.replace(/^0/, '');
    },
    [items],
  );

  const handleInputBlur = useCallback(
    (e: React.FormEvent<HTMLInputElement>, mat: string) => {
      const index = items.findIndex((item: ItemsProps) => item.matcod === mat);
      if (e.currentTarget.value === '0') {
        setItems((state) =>
          [...state].filter(
            (item: ItemsProps) => item.matcod !== items[index].matcod,
          ),
        );

        const rearrange = [
          ...mats,
          rawMats[
            rawMats.findIndex(
              (item: ComboProps) => item.value === items[index].matcod,
            )
          ],
        ].sort((a, b) => (a.label > b.label ? 1 : -1));

        setMats(rearrange);
      }
    },
    [items, mats, rawMats],
  );

  const handlePreIncInput = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      setAccept(e.currentTarget.value.toLowerCase());

      return e.currentTarget.value;
    },
    [],
  );

  const handleRemoveItem = useCallback(
    (mat: string) => {
      const index = items.findIndex((item: ItemsProps) => item.matcod === mat);

      setItems((state) =>
        state.filter((item: ItemsProps) => item.matcod !== mat),
      );

      const rearrange = [
        ...mats,
        rawMats[
          rawMats.findIndex(
            (item: ComboProps) => item.value === items[index].matcod,
          )
        ],
      ].sort((a, b) => (a.label > b.label ? 1 : -1));

      setMats(rearrange);
    },
    [items, mats, rawMats],
  );

  const handleOBSChange = useCallback(
    (e: React.FormEvent<HTMLTextAreaElement>) => {
      const newstring = e;
      alphaMasking(newstring);

      return newstring;
    },
    [],
  );

  const handleFinish = useCallback(async () => {
    try {
      setLoading(true);
      const data = {
        items,
        address: {
          value: phaseThree.current?.getFieldValue('deliver') || 'P',
          label: deliverAddress,
        },
        obs: phaseThree.current?.getFieldValue('obs').replace('#', ''),
        name: user.name,
        anbdesc: user.anbdesc,
        total,
      };

      const send = new FormData();
      send.append('data', JSON.stringify(data));

      const response = await api.post('/sgo/pedido_insert.php', send, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      const { pednum } = response.data;

      addToast({
        type: 'success',
        title: 'Sucesso!',
        description: `Pedido N° ${pednum} registrado.`,
      });

      history.replace(pathname.replace('/insert', ''));
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandling(err);
    }
  }, [
    addToast,
    deliverAddress,
    errorHandling,
    history,
    items,
    pathname,
    total,
    user.anbdesc,
    user.name,
  ]);

  const preIncStyle = useSpring({
    opacity: isPreInc ? 1 : 0,
    transform: isPreInc ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPreInc ? 'all' : 'none',
    display: isPreInc ? 'inline' : 'none',
  });

  const phaseOneStyle = useSpring({
    opacity: isPhaseOne ? 1 : 0,
    transform: isPhaseOne ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPhaseOne ? 'all' : 'none',
    display: isPhaseOne ? 'inline' : 'none',
  });
  const phaseTwoStyle = useSpring({
    opacity: isPhaseTwo ? 1 : 0,
    transform: isPhaseTwo ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPhaseTwo ? 'all' : 'none',
    display: isPhaseTwo ? 'inline' : 'none',
  });
  const phaseThreeStyle = useSpring({
    opacity: isPhaseThree ? 1 : 0,
    transform: isPhaseThree ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPhaseThree ? 'all' : 'none',
    display: isPhaseThree ? 'inline' : 'none',
  });
  const toggleFlexDirection = useSpring({
    flexDirection: width < 400 && total > 99.99 ? 'column' : 'row',
  });

  const styledProceedPreInc = useSpring({
    transform:
      accept === 'aceito' && !!isPreInc
        ? 'translateX(5px)'
        : 'translateX(60px)',
    opacity: accept === 'aceito' && !!isPreInc ? 1 : 0,
    pointerEvents: accept === 'aceito' && !!isPreInc ? 'all' : 'none',
  });
  const styledProceedPhaseTwo = useSpring({
    transform: items.length > 0 ? 'translateX(5px)' : 'translateX(60px)',
    opacity: items.length > 0 ? 1 : 0,
    pointerEvents: items.length > 0 ? 'all' : 'none',
  });

  return (
    <Container>
      <Loading isLoading={loading} />
      <ScrollTop />
      <SGOHeader />
      <SGONavbar
        noLinks
        title={`Pedido de Material${
          groupSelected.desc ? ` de ${groupSelected.desc}` : ''
        }`}
      />
      <Content>
        <PreINC style={preIncStyle}>
          <AlteredHeader>Atenção</AlteredHeader>
          <p>
            A partir da criação do Pedido de Material da sua Nacional para a TOV
            ZONA BRASIL, todas as Solicitações de Material das Coordenações
            Locais de sua responsabilidade serão <strong>bloqueadas</strong>{' '}
            para alteração ou exclusão.
          </p>
          <p>
            Para prosseguir, digite a palavra <strong>ACEITO</strong> na caixa
            abaixo e pressione o botão &quot;Prosseguir&quot;
          </p>
          <span>
            <input
              type="text"
              min={0}
              onChange={(e: React.FormEvent<HTMLInputElement>) =>
                handlePreIncInput(e)
              }
              onBlur={(e: React.FormEvent<HTMLInputElement>) =>
                handlePreIncInput(e)
              }
            />
          </span>

          <ProceedButton
            style={styledProceedPreInc}
            onClick={() => {
              setIsPhaseOne((state) => !state);
              setIsPreInc((state) => !state);
            }}
          >
            Prosseguir
          </ProceedButton>
        </PreINC>

        <PhaseOne style={phaseOneStyle}>
          <Form
            ref={phaseOne}
            onSubmit={() => {
              return null;
            }}
          >
            <PhaseOneItemContainer>
              <RadioContainer
                title="Realizar pedido para:"
                onClick={handleRadioClick}
                name="group"
                content={[
                  {
                    id: 'gG',
                    value: 'G',
                    label: 'Gráfica',
                    icon: FaBook,
                  },
                  // {
                  //   id: 'gM',
                  //   value: 'C',
                  //   label: 'Malharia',
                  //   icon: FaTshirt,
                  // },
                  {
                    id: 'gC',
                    value: 'M',
                    label: 'Mídias',
                    icon: FaPhotoVideo,
                  },
                ]}
                asColumn
              />
            </PhaseOneItemContainer>
          </Form>
        </PhaseOne>
        <PhaseTwo style={phaseTwoStyle}>
          <Form ref={phaseTwo} onSubmit={() => null}>
            <ItemContainer>
              <span>
                <SelectV2
                  name="material"
                  content={mats}
                  initial="Selecione"
                  onChange={handleMaterialSelect}
                />
              </span>
              <span>
                <p>Seu estoque:</p>
                <strong>{storageQuantity}</strong>
              </span>
            </ItemContainer>
            <AddButton type="button" onClick={handlePushMaterial}>
              <FaPlusSquare /> <p>Adicionar material</p>
            </AddButton>
            <InfoContainer>
              <TotalSolic style={toggleFlexDirection}>
                <p>Total deste pedido:&nbsp;</p>
                <strong>R$ {formatNumber(total)}</strong>
              </TotalSolic>

              <FinishButton
                style={styledProceedPhaseTwo}
                type="button"
                onClick={() => {
                  setIsPhaseTwo((state) => !state);
                  setIsPhaseThree((state) => !state);
                }}
              >
                Avançar
              </FinishButton>
            </InfoContainer>
          </Form>
          <Grid>
            {items.map((item: ItemsProps) => (
              <GridItem key={item.matcod}>
                <div>
                  <strong>
                    {item.matcod} - {item.matdesc}
                  </strong>
                </div>

                <div>
                  <span>
                    <p>
                      Custo:&nbsp;<strong>R$ {formatNumber(item.cost)}</strong>
                    </p>
                  </span>
                  <span>
                    <p>Quantidade:</p>
                    <span>
                      <FaSortUp
                        onClick={() => handleAdd(item.matcod)}
                        style={{
                          transform: 'translateY(10px)',
                          color: '#009933',
                        }}
                      />

                      <input
                        type="number"
                        min={0}
                        value={item.quantity}
                        onChange={(e: React.FormEvent<HTMLInputElement>) =>
                          handleInputChange(e, item.matcod)
                        }
                        onBlur={(e: React.FormEvent<HTMLInputElement>) =>
                          handleInputBlur(e, item.matcod)
                        }
                      />

                      <FaSortDown
                        onClick={() => handleSub(item.matcod)}
                        style={{
                          transform: 'translateY(-10px)',
                          color: '#c53030',
                        }}
                      />
                    </span>
                    <figure>
                      <FaTimesCircle
                        onClick={() => handleRemoveItem(item.matcod)}
                      />
                    </figure>
                  </span>
                </div>
                <div>
                  <span>
                    <p>
                      Estoque atual:&nbsp;
                      <strong>{item.stored}</strong>
                    </p>
                  </span>
                </div>
                <div>
                  <span>
                    <p>
                      Total:&nbsp;
                      <strong>R$ {calcTotal(item.quantity, item.cost)}</strong>
                    </p>
                  </span>
                </div>
              </GridItem>
            ))}
          </Grid>
        </PhaseTwo>
        <PhaseThree style={phaseThreeStyle}>
          <ReturnButton
            onClick={() => {
              setIsPhaseTwo((state) => !state);
              setIsPhaseThree((state) => !state);
            }}
          >
            <FaArrowLeft />
            <p>Retornar aos itens</p>
          </ReturnButton>
          <Form
            ref={phaseThree}
            onSubmit={() => {
              return null;
            }}
          >
            <div>
              {deliverAble && (
                <RadioContainer
                  title="Endereço de Entrega:"
                  onClick={handleRadioClick2}
                  name="deliver"
                  content={[
                    {
                      id: 'dT',
                      value: 'P',
                      label: 'Escritório Nacional',
                    },
                    {
                      id: 'dL',
                      value: 'S',
                      label: 'Endereço Alternativo',
                    },
                  ]}
                  selected="P"
                />
              )}

              <p>{deliverAddress}</p>
            </div>
            <div>
              <p>Observação:</p>
              <Textarea
                name="obs"
                placeholder="Insira a observação (opcional)"
                onChange={(e: React.FormEvent<HTMLTextAreaElement>) =>
                  handleOBSChange(e)
                }
              />
            </div>
          </Form>
          <Button onClick={handleFinish} bgcolor="#00802b">
            Finalizar
          </Button>
        </PhaseThree>
      </Content>

      <SGOFooter />
    </Container>
  );
};

export default PedidoInsert;
